<template lang="html">

  <section class="home-testimonial">

					<!-- <div class="arrow_left"><i class="fa fa-chevron-left"></i></div>
					<div class="arrow_right"><i class="fa fa-chevron-right"></i></div>
					<div class="bxslider">
						<div><a href="https://www.risklatte.xyz/media/player.php?id=100"><img src="./../../assets/images/media_slide1.jpg" alt=""></a></div>
						<div><a href="https://www.risklatte.xyz/media/player.php?id=96"><img src="./../../assets/images/media_slide.jpg" alt=""></a></div>
						<div><a href="https://www.risklatte.xyz/media/player.php?id=97"><img src="./../../assets/images/a-universe-of-endless-possibilities.jpg" alt=""></a></div>
						<div><a href="https://www.risklatte.xyz/media/player.php?id=99"><img src="./../../assets/images/welcome-to-carr-challenge.jpg" alt=""></a></div>
						<div><a href="https://www.risklatte.xyz/media/player.php?id=98"><img src="./../../assets/images/sholom-benzev-wins-carr-challenge-snap-quiz.jpg" alt=""></a></div>
						<div><a href="https://www.risklatte.xyz/media/player.php?id=101"><img src="./../../assets/images/shaping-the-future-of-education.jpg" alt=""></a></div>
						<div><a href="https://www.risklatte.xyz/media/player.php?id=95"><img src="./../../assets/images/peter-carr-talks-about-risk-lattes-global-quiz-competition.jpg" alt=""></a></div>
					</div>  -->

          <carousel v-bind:perPageCustom="[[320, 1], [768, 2], [991, 3]]" v-bind:navigationEnabled="true" v-bind:scrollPerPage="false">
        <slide>  <div><a href="https://www.oddvega.com/media/details/ea9f1fd3-831d-45e9-81c3-01a3901e4851"><img src="./../../assets/images/media_slide1.jpg" alt=""></a></div> </slide>
        <slide>  <div><a href="https://www.oddvega.com/media/details/46b85708-9c8d-4e57-bc4e-ba37583c0172"><img src="./../../assets/images/media_slide.jpg" alt=""></a></div> </slide>
        <slide>  <div><a href="https://www.oddvega.com/media/details/2cce2d9d-6f42-431f-be38-41933bdd4a8d"><img src="./../../assets/images/a-universe-of-endless-possibilities.jpg" alt=""></a></div> </slide>
        <slide>  <div><a href="https://www.oddvega.com/media/details/553cacbe-821c-409b-bd0d-690990738ebb"><img src="./../../assets/images/welcome-to-carr-challenge.jpg" alt=""></a></div> </slide>
        <slide>  <div><a href="https://www.oddvega.com/media/details/5f96be56-aa82-4e3a-995e-07d945c5c7e6"><img src="./../../assets/images/sholom-benzev-wins-carr-challenge-snap-quiz-new.jpg" alt=""></a></div> </slide>
        <slide>  <div><a href="https://www.oddvega.com/media/details/9c5b12fc-be9a-452e-9d9a-522081bfbbba"><img src="./../../assets/images/shaping-the-future-of-education.jpg" alt=""></a></div> </slide>
        <slide>   <div><a href="https://www.oddvega.com/media/details/892c57bf-0c26-421b-ae02-8bb4fe5b2ddb"><img src="./../../assets/images/peter-carr-talks-about-risk-lattes-global-quiz-competition.jpg" alt=""></a></div> </slide>
    </carousel>


  </section>

</template>

<script lang="js">
import { Carousel, Slide } from 'vue-carousel';
  export default  {
    name: 'home-media',
    props: [],
    components: {
      Carousel,
    Slide
    },
    mounted() {

    },
    data() {
      return {
        slickOptions: {
            slidesToShow: 1,
        },
      }
    },
    methods: {
      next() {
              this.$refs.slick.next()
      },
      prev() {
              this.$refs.slick.prev()
      },
      reInit() {
              // Helpful if you have to deal with v-for to update dynamic lists
              this.$refs.slick.reSlick()
      }
    },
    computed: {

    }
}
</script>

<style lang="css">
  .home-testimonial{
    margin: 0 -5px;
  }

  .VueCarousel-dot{
    padding: 1px !important;
    margin: 0 5px !important;
    background: none !important;
    border: solid 1px #fff !important;
    width: 7px !important;
    height: 7px !important;
  }

  .VueCarousel-dot:focus{
    outline: none !important;
    box-shadow: none !important;
  }

  .VueCarousel-dot.VueCarousel-dot--active{
    background: #fff !important;
  }

  .VueCarousel-navigation-prev,
  .VueCarousel-navigation-prev[data-v-453ad8cd]{
    transform: translateY(-70%) translateX(11%);
  }
  .VueCarousel-navigation-next,
  .VueCarousel-navigation-next[data-v-453ad8cd] {
    transform: translateY(-70%) translateX(-23%);
  }

  .VueCarousel-navigation--disabled,
  .VueCarousel-navigation--disabled{
    opacity: 1;
  }

  .arrow_left .bx-prev,
.arrow_right .bx-next {
    font-size: 0;
    width: 35px;
    width: 35px;
    position: absolute;
}

.arrow_left,
.arrow_right {
    width: 35px;
    height: 35px;
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
    top: 50%;
    z-index: 100;
    text-align: center;
    line-height: 35px;
    font-size: 16px;
    color: #fff;
}

.arrow_left,
.arrow_left .bx-prev {
    left: 0;
}

.arrow_right,
.arrow_right .bx-next {
    right: 0;
}

 .bx-wrapper {
  background: none;
  border: none;
  box-shadow: none;
  margin-bottom: 60px;
}

 .bx-wrapper .bx-controls.bx-has-controls-auto.bx-has-pager .bx-pager {
  width: 100%;
  text-align: center;
}

 .bx-wrapper .bx-pager.bx-default-pager a {
  background: none;
  border: 1px solid #fff;
}

.bx-wrapper .bx-pager.bx-default-pager a.active {
  background: #ffffff;
}

</style>
